import {post} from '../utils'

const url = (host, channelId, userId,) => `${host}/channels/${channelId}/user/${userId}/approve`

export default host => (channelId, userId, status) =>
  post(url(host, channelId, userId,), JSON.stringify({approve: status}))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)